








import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  data: any[]
}>(
  {
    props: ['data'],
  },
  () => class {},
)
